/**
 * Base da API usada pelo axios/fetch.
 *
 * Em produção o deploy deve usar caminho relativo (ex.: `/api/v1`) para o browser
 * chamar o mesmo host do admin; o Nginx faz proxy de `/api/` para o backend.
 * Nunca usar `localhost` como fallback em build de produção — sem `VITE_*` no build,
 * o bundle antigo apontava para a máquina do usuário.
 */
export function getApiBaseUrl(): string {
  const v = import.meta.env.VITE_API_BASE_URL;
  if (typeof v === 'string' && v.trim() !== '') {
    return v.trim();
  }
  return '/api/v1';
}

export const API_BASE_URL = getApiBaseUrl();
